import React from 'react'
import PropertyLogo from '../../../../PropertyLogo'
import { useStore } from '../../../../../store'

function OfficesPropertyLogo(props) {
  const { data } = useStore()

  return (
    <div className=" bg-[#fff]  rounded-[6px] lg:shadow-sm h-[40px] lg:px-[16px] lg:flex items-center justify-center max-w-[400px]">
      <PropertyLogo className='h-[20px] lg:h-[24px]' />
      <span className="truncate landscape:hidden lg:landscape:inline-block text-[14px] lg:text-[16px] lg:ml-[16px] font-medium inline-block mt-[4px] lg:mt-[0]">{data.property.property_name}</span>
    </div>
  )
}

export default OfficesPropertyLogo
